import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DatePicker from '../../Components/DatePicker/DatePicker';
import Modal from '../../Components/Modal/Modal';
import RadioButtonGroup from '../../Components/RadioButtonGroup/RadioButtonGroup';
import { Button } from '../../Components/StyledComponents';
import { convertCost } from '../../Utils/functions';
import AgeChart from './Charts/AgeChart';
import DeliveryChart, { delvieryMockData } from './Charts/DeliveryChart';
import GenderChart from './Charts/GenderChart';
import PointChart from './Charts/PointChart';
import SalesChart, { salesMockData } from './Charts/SalesChart';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import ko from 'date-fns/locale/ko'

import './Calendar.css'

import './Stats.scss';
import { useChannelIOApi } from 'react-channel-plugin';

const initStat= { //스탯 정보 초기값
    "TotalUser": 0,
    "Deposit": 0,
    "RegDate": {
        "$date": 0
    },
    "PointRate": 0,
    "ExpiryDate": {
        "$date": 0
    },
    "ShowStats": true,
    "StatInfo": {
        "PriceStats": {
            "Price": 0,
            "Count": 0,
            "Visit": {
                "Price": 0,
                "Count": 0
            },
            "Delivery": {
                "Price": 0,
                "Count": 0,
                "Platform": {
                    "Baemin": {
                        "Price": 0,
                        "Count": 0
                    },
                    "Eats": {
                        "Price": 0,
                        "Count": 0
                    },
                    "Yogiyo": {
                        "Price": 0,
                        "Count": 0
                    }
                }
            }
        },
        "PointStats": {
            "Total": 0,
            "Add": 0,
            "Used": 0,
            "AddPoint": 0,
            "UsedPoint": 0,
            "Gender": {
                "Male": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "Female": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                }
            },
            "Age": {
                "10": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "20": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "30": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "40": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "50": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                },
                "60": {
                    "Total": 0,
                    "Add": 0,
                    "Used": 0,
                    "AddPoint": 0,
                    "UsedPoint": 0
                }
            },
            "Visit": {
                "Total": 0,
                "Add": 0,
                "Used": 0,
                "AddPoint": 0,
                "UsedPoint": 0
            },
            "Delivery": {
                "Total": 0,
                "Add": 0,
                "Used": 0,
                "AddPoint": 0,
                "UsedPoint": 0
            }
        },
        "SMSStats": {
            "SendReq": 0,
            "Send": 0,
            "Coupon": 0,
            "NonCoupon": 0
        },
        "CouponStats": {
            "Issued": 0,
            "Used": 0,
            "WonUsed": 0,
            "PerUsed": 0,
            "FreeUsed": 0,
            "OnePlusUsed": 0
        },
        "UserStats": {
            "New": 0
        }
    }
}

const locales = {
    'ko': ko,
  }
  
  //Datepicker localize
  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  })

const dayList = ['','일','월','화','수','목','금','토']

//const localizer = momentLocalizer(moment)

const Stats = () => {
    const [ storeName, setStoreName ] = useState('');//매장명
    const [ startDate, setStartDate ] = useState(new Date(moment(new Date()).format('YYYY-MM-01')));//조회 시작일
    const [ endDate, setEndDate ] = useState(new Date());//조회 마지막일
    const [ startTempDate, setStartTempDate] = useState(new Date(moment(new Date()).format('YYYY-MM-01')));//시작일 임시 저장
    const [ endTempDate, setEndTempDate ] = useState(new Date());//마지막일 임시 저장
    const [ chartType, setChartType ] = useState('hour')//매출 분석 차트 타입
    const [ pointType, setPointType ] = useState('add')//포인트 분석 차트 타입
    const [ aegType, setAgeType ] = useState('add')//연령별 통계 차트 타입
    const [ genderType, setGenderType ] = useState('add')//성별 통계 차트 타입
    const [ info, setInfo ] = useState(initStat)//통계 정보
    const [salesData, setSalesData] = useState([])//매출 통계
    const [ isActive, setIsActive ] = useState(true)//통계 활성화 여부
    const [ calendarStat, setCalendarStat ] = useState([]);//통계 캘린더 정보
    const [ calendarYear, setCalendarYear] = useState(moment(new Date).format('YYYY'))//통계 캘린더 연도
    const [ calendarMonth, setCalendarMonth] = useState(moment(new Date).format('MM'))//통계 캘린더 월
    const [ moreDate, setMoreDate ] = useState({})//통계 캘린더 더보기 정보
    const [ scrollLeft ,setScrollLeft ] = useState(0)//매출 분석 차트 스크롤
    const [ isLast, setIsLast ] = useState(false)//매출 분석 차트 스크롤 마지막 체크
    const [ isFirst, setIsFirst ] = useState(true)//매출 분석 차트 스크롤 시작 체크
    const [ init, setInit] = useState(false)//데이터 Init 여부 체크

    const salesRef = useRef(null);//매출 분석 차트 ref
    const modalRef = useRef(null);//모달 ref
    const calendarRef = useRef(null);//통계 캘린더 ref
    const calendarModalRef = useRef(null);//통계 캘린더 모달 ref
    const moreCalendarRef = useRef(null);//통계 캘린더 더보기 모달 ref

    const navigate = useNavigate();
    const { showMessenger } = useChannelIOApi();//체널톡 오픈

    useEffect(() => {
        getStats(moment(startDate).format('YYYY-MM-01'),moment(endDate).format('YYYY-MM-DD'));
        let name = localStorage.getItem('storeName')
        setStoreName(name)
    },[])

    //통계 정보 get
    const getStats = (start,end) => {
        axios.get('/api/stats?start=' + start + '&end=' + end )
        .then((data) => {
            setInfo(data.data)
            if(data.data.ShowStats) setIsActive(true)
            else setIsActive(false)
            setInit(true)
            getChart(start,end,chartType);
        })
        .catch(() => {
            
        })
    }

    //통계 캘린더 정보 Get
    const getCalendar = (year,month) => {
        axios.get(`/api/stats/calendar?date=${year}-${month}`)
        .then((data) => {
            let arr = []
            for(let i=0; i<data.data.StatInfo.length; i++){
                arr.push({
                    title : '누적 사용자 : ' + convertCost(data.data.StatInfo[i].UserStats.Old + data.data.StatInfo[i].UserStats.New) + ' 명',
                    start : moment(data.data.StatInfo[i].StatDate.$date).utc(),
                    end : moment(data.data.StatInfo[i].StatDate.$date).utc()
                })

                arr.push({
                    title : '- 신규 사용자 : ' + convertCost(data.data.StatInfo[i].UserStats.New) + ' 명',
                    start : moment(data.data.StatInfo[i].StatDate.$date).utc(),
                    end : moment(data.data.StatInfo[i].StatDate.$date).utc()
                })

                arr.push({
                    title : '총 매출 : ' + convertCost(data.data.StatInfo[i].PriceStats.Price) + ' 원',
                    start : moment(data.data.StatInfo[i].StatDate.$date).utc(),
                    end : moment(data.data.StatInfo[i].StatDate.$date).utc()
                })

                arr.push({
                    title : '- 배달 : ' + convertCost(data.data.StatInfo[i].PriceStats.Delivery.Price) + ' 원',
                    start : moment(data.data.StatInfo[i].StatDate.$date).utc(),
                    end : moment(data.data.StatInfo[i].StatDate.$date).utc()
                })

                arr.push({
                    title : '- 홀 : ' + convertCost(data.data.StatInfo[i].PriceStats.Visit.Price) + ' 원',
                    start : moment(data.data.StatInfo[i].StatDate.$date).utc(),
                    end : moment(data.data.StatInfo[i].StatDate.$date).utc()
                })
            }
            setCalendarStat(arr)
        })
    }

    //ChartType 바뀔때마다 매출 분석 차트 정보 get
    useEffect(() => {
        if(init)getChart(moment(startDate).format('YYYY-MM-DD'),moment(endDate).format('YYYY-MM-DD'),chartType);
    },[chartType])

    //매출 분석 Get
    const getChart = (start,end,type = 'hour') => {
        axios.get('/api/stats/chart?start=' + start + '&end=' + end +'&type=' + type )
        .then((data) => {
            setScrollLeft(0)
            salesRef.current.scrollLeft = 0
            let arr = [];
            for(let i=0; i < data.data.StatInfo.length; i++){
                arr.push({
                    "keys" : type === 'day' ? dayList[data.data.StatInfo[i].DayOfWeek] : type === 'hour' ? data.data.StatInfo[i].Hour + '~' + (parseInt(data.data.StatInfo[i].Hour) + 1) + '시' : data.data.StatInfo[i].Month + '월',
                    "전체" : parseInt((data.data.StatInfo[i].Visit + data.data.StatInfo[i].Delivery)/data.data.StatInfo[i].Count),
                    "홀" : parseInt(data.data.StatInfo[i].Visit/data.data.StatInfo[i].Count),
                    "배달" : parseInt(data.data.StatInfo[i].Delivery/data.data.StatInfo[i].Count),
                })
            }
            //배열 길이가 8이상이면 오른쪽 스크롤 버튼 활성화
            if(arr.length < 8) setIsLast(true)
            else setIsLast(false)
            setSalesData(arr)
            setChartType(type)
        })
        .catch(() => {
        })
    }

    //통계 기간 조회
    const searchDate = () => {
        setStartDate(startTempDate)
        setEndDate(endTempDate)
        getStats(moment(startTempDate).format('YYYY-MM-DD'),moment(endTempDate).format('YYYY-MM-DD'));
    }

    //통계 전체 기간 조회
    const searchAllDate = () => {
        let regDate = moment(info.RegDate.$date).utc().format('YYYY-MM-DD')
        setStartDate(new Date(regDate));
        setStartTempDate(new Date(regDate))
        setEndDate(new Date())
        setEndTempDate(new Date())
        getStats(regDate,moment(endDate).format('YYYY-MM-DD'));
    }

    //통계 캘린더 Open
    const openCalendarModal = () => {
        getCalendar(calendarYear,calendarMonth)
        calendarModalRef.current.openModal();
    }

    //통계 캘린더 Prop 총 매출,누적 사용자에 event-highlight class 적용
    const eventPropGetter = useCallback(
        (event, start, end, isSelected) => ({
          ...((event.title.includes('총 매출') || event.title.includes('누적 사용자')) ? {
            className: 'event-highlight',
          }
          :
          {
              className : 'event'
          }
          ),
        }),
        []
    )

    //통계 캘린더 월 변경 handler
    const handleCalendarDate = (val) => {
        if(val === 'back'){
            let newYear = moment(calendarYear + '-' + calendarMonth + '-01').subtract(1,'months').format('YYYY');
            let newMonth = moment(calendarYear + '-' + calendarMonth + '-01').subtract(1,'months').format('MM');
            setCalendarYear(newYear)
            setCalendarMonth(newMonth)
            getCalendar(newYear,newMonth)
        }else {
            let newYear = moment(calendarYear + '-' + calendarMonth + '-01').add(1,'months').format('YYYY');
            let newMonth = moment(calendarYear + '-' + calendarMonth + '-01').add(1,'months').format('MM');
            setCalendarYear(newYear)
            setCalendarMonth(newMonth)
            getCalendar(newYear,newMonth)
        }
    }

    //통계 캘린더 더보기 Function 
    const onShowMore = useCallback(
        (events, date) => {setMoreDate({ event : events, date : date} );moreCalendarRef.current.openModal();},
        []
    )

    //매출 분석 chart scroll handler
    const handleScrollMax = (val) => {
        if(scrollLeft + val < salesRef.current.scrollWidth - 860 &&  scrollLeft + val >= 0){
            setScrollLeft(old => old + val);
            //scrollLeft.current += val;
            salesRef.current.scrollLeft = scrollLeft+val;
        }else if( scrollLeft + val < 0){
            setScrollLeft(0);
            salesRef.current.scrollLeft = 0;
        }else if( scrollLeft + val > salesRef.current.scrollWidth - 860){
            setScrollLeft(salesRef.current.scrollWidth - 860);
            salesRef.current.scrollLeft = salesRef.current.scrollWidth - 860;
        }
    }

    //매출 분석 Chart onScroll Event Handler
    const onScroll = (e) => {
        setScrollLeft(e.target.scrollLeft)
        if(e.target.scrollLeft >= e.target.scrollWidth - 860) setIsLast(true)
        else setIsLast(false)
        if(e.target.scrollLeft === 0) setIsFirst(true)
        else setIsFirst(false)
    }

    return (
        <div className='stats'>
            {
                Object.keys(info).length > 0 &&
                <div className='stats-wrapper'>
                    <p className='title'>안녕하세요,<br/>{storeName} 사장님!</p>
                    {
                        !isActive &&
                        <div className='stat-box' style={{ marginBottom : 24, width : 940 }}>
                            <div className='row'>
                                <p className='top-title'>현재</p>
                                <p className='top-title' style={{ color : '#f95f53'}}>&nbsp;매출 데이터 분석</p>
                                <p className='top-title'>이 활성화 되어있지 않습니다.</p>
                            </div>
                            <div className='row between'>
                                <p className='top-desc'>분석된 매출 데이터를 제공받고<br/>담당 매니저의 컨설팅을 통해<br/>{storeName} 매장에 대해 더욱 상세하게 알아보세요!</p>

                                <Button variant='sub' style={{ width : 114, marginTop : 16 }} onClick={showMessenger}>
                                    데이터 분석받기
                                </Button>
                            </div>
                        </div>
                    }

                    <div className='row between'>
                        <div className="row">
                            <DatePicker value={startTempDate} onChange={(date) => setStartTempDate(date)} style={{ width : 200, backgroundColor : 'white' }}/>
                            <p className="tilde">~</p>
                            <DatePicker value={endTempDate} onChange={(date) => setEndTempDate(date)} style={{ width : 200 }}/>
                            <p className="tilde-text">까지의 통계</p>
                        </div>

                        <div className='row'>
                            <Button variant='main' small style={{ padding : 8, paddingBottom : 0 }} onClick={() => searchDate()} disabled={!isActive}>
                                <img alt='icon' src={require('../../aseets/icons/search_white.svg').default} style={{ width : 24, height : 24 }} />
                            </Button>
                            <Button variant='sub' small style={{ marginLeft : 8, paddingLeft : 16, paddingRight : 16, marginRight : 60 }} onClick={() => searchAllDate()} disabled={!isActive}>
                                전체기간 조회
                            </Button>

                            <Button variant='outline' small style={{ marginLeft : 8, paddingLeft : 16, paddingRight : 16}} onClick={() => openCalendarModal()} disabled={!isActive}>
                                <div className='row'>
                                {
                                    isActive ?
                                    <img alt='icon' src={require('../../aseets/icons/calendar_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                                    :
                                    <img alt='icon' src={require('../../aseets/icons/calendar_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                                }
                                통계캘린더
                                </div>
                            </Button>
                        </div>
                    </div>

                    <div className='row between' style={{ marginTop : 40 }}>
                        <div className='stat-box'>
                            <div className='type-box'>
                                매장 통계
                            </div>

                            <div className='row between' style={{ marginBottom : 8 }}>
                                <p className='box-title'>누적 사용자</p>
                                <p className='box-text'>{convertCost(info.TotalUser)} 명</p>
                            </div>
                            <div className='row between' style={{ marginBottom : 8 }}>
                                <p className='box-title'>신규 사용자</p>
                                {
                                    (typeof info.StatInfo.UserStats !== 'undefined') ?
                                    <p className='box-text'>{convertCost(info.StatInfo.UserStats.New)} 명</p>
                                    :
                                    <p className='box-text'>- 명</p>
                                }
                            </div>
                            <div className='row between' style={{ marginBottom : 8 }}>
                                <p className='box-title'>배달 매출</p>
                                <p className='box-text'>{isActive ? convertCost(info.StatInfo.PriceStats.Delivery.Price) : '***,***'} 원</p>
                            </div>
                            <div className='row between' style={{ marginBottom : 8 }}>
                                <p className='box-title'>홀 매출</p>
                                <p className='box-text'>{isActive ?  convertCost(info.StatInfo.PriceStats.Visit.Price) : '***,***'} 원</p>
                            </div>
                            <div className='row between' style={{ marginBottom : 8 }}>
                                <p className='box-title'>예상 매출</p>
                                <p className='box-text' style={{ fontSize : 24, fontWeight : 'bold'}}>{isActive ?  convertCost(info.StatInfo.PriceStats.Price) : '**,***,***'} 원</p>
                            </div>
                            <div className='row'>
                                <img alt='icon' src={require('../../aseets/icons/stat-alert.svg').default} style={{ width : 24, height : 24, marginRight : 4 }} />
                                <p className='info-text'>위 예상 매출은 실제 매출과 상이할 수 있습니다.</p>
                            </div>
                        </div>

                        <div className='stat-box'>
                            <div className='type-box'>
                                문자/쿠폰 분석
                            </div>

                            <div className='row between' style={{ marginBottom : 12 }}>
                                <p className='box-title'>문자 발송 수</p>
                                <p className='box-text'>{convertCost(info.StatInfo.SMSStats.Send)} 건</p>
                            </div>
                            <div className='row between' style={{ marginBottom : 12 }}>
                                <p className='box-title'>쿠폰 발행 수</p>
                                <p className='box-text'>{convertCost(info.StatInfo.CouponStats.Issued)} 건</p>
                            </div>
                            <div className='row between' style={{ marginBottom : 2 }}>
                                <p className='box-title'>쿠폰 사용 수</p>
                                <p className='box-text'>{convertCost(info.StatInfo.CouponStats.Used)} 건</p>
                            </div>
                            <p className='box-text-warn' style={{ marginBottom : 12, }}>* 쿠폰 사용으로 발생된 예상매출 {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Price/info.StatInfo.PriceStats.Count * info.StatInfo.CouponStats.Used - info.StatInfo.CouponStats.Used * 44 )) : '*,***,***'}원</p>
                            <div className='row between' style={{ marginBottom : 28 }}>
                                <p className='box-title'>쿠폰 반응률</p>
                                <p className='box-text'>{convertCost((info.StatInfo.CouponStats.Used/info.StatInfo.CouponStats.Issued * 100).toFixed(2))}%</p>
                            </div>
                            <p className='coupon-type' onClick={() => modalRef.current.openModal()}>쿠폰 타입별 통계 {'>'}</p>
                        </div>

                        <div className='stat-box'>
                            <p className='store-name'>{storeName}</p>
                            <p className='jungsan-text'>현재 정산 가능 금액은</p>
                            <div className='row' >
                                <p className='jungsan-text-bold'>{convertCost(info.Deposit)}</p>
                                <p className='jungsan-text'>&nbsp;원 입니다.</p>
                            </div>

                            <div className='jungsan-box'>
                                <Button variant='main' style={{ width : 132, paddingTop : 8, paddingBottom : 8 }} fontSize={14} onClick={() => navigate('/jungsan')}>
                                    정산하기
                                </Button>
                                <NavLink to='/jungsan'>
                                    <Button variant='main' style={{ width : 132, paddingTop : 8, paddingBottom : 8, marginTop : 8, marginBottom : 24, backgroundColor : '#f5f5f5', color : '#9f9f9f' }} fontSize={14}>
                                        정산내역 보러가기
                                    </Button>
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className='stat-box' style={{ width : 940, marginTop : 40, padding : 40 }}>
                        {/* <div className='blur'>
                            <p className='block-text'>해당 자료를 확인하고 싶으시면 문의해주세요.</p>
                            <Button variant='sub' style={{ width : 114 }} id="open-chat-btn">
                                문의하기
                            </Button>
                        </div> */}
                        <p className='store-name' style={{ marginBottom : 0 }}>{storeName}</p>
                        <p className='stat-title' style={{ marginBottom : 16 }}>매출 분석</p>
                        
                        <RadioButtonGroup
                            value={chartType}
                            checked={chartType}
                            onChange={(val) => setChartType(val)}
                            options={[
                                { value : 'hour', label : '시간별'},
                                { value : 'day', label : '요일별'},
                                { value : 'month', label : '월별'}
                            ]}
                            perRows={11}
                            radioStyle={{ marginBottom : 24 }}
                            small
                            disabled={!isActive}
                            containerStyle={{ justifyContent : 'flex-start'}}
                            id="chart"
                        />
                        <div className='row'>
                            <p className='box-title'>- 총 매출 : </p>
                            <p className='box-title' style={{ color : '#3f3f3f'}}>&nbsp;{isActive ? convertCost(info.StatInfo.PriceStats.Price) : '***,***,***'} 원</p>
                            <p className='box-title' style={{ marginLeft : 16 }}>- 결제 1건당 평균 가격 : </p>
                            <p className='box-title' style={{ color : '#3f3f3f'}}>&nbsp;{isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Visit.Price/info.StatInfo.PriceStats.Visit.Count)) : '**,***'} 원</p>
                        </div>
                        {
                            !isActive &&
                            <p className='warn-text'>* 아래 보여지는 차트는 가상의 데이터입니다.</p>
                        }
                        <div className='sales-chart-box' ref={salesRef} id='salesChart' onScroll={onScroll}>
                            <SalesChart data={ isActive ? salesData : salesMockData}/>
                        </div>

                        {
                            !isLast &&
                            <div className='move-right' onClick={() => handleScrollMax(100)}>
                                <img alt='icon' src={require('../../aseets/icons/right-arrow-white.svg').default} style={{ width : 40, height : 40 }} />
                            </div>
                        }                        

                        {
                            !isFirst &&
                            <div className='move-left' onClick={() => handleScrollMax(-100)}>
                                <img alt='icon' src={require('../../aseets/icons/left-arrow-white.svg').default} style={{ width : 40, height : 40 }} />
                            </div>
                        }
                    </div>

                    <div className='row between' style={{ marginTop : 40}}>
                        <div className='stat-box' style={{ width : 460, height : 722, overflow : 'hidden', padding : 40  }}>
                            <p className='store-name' style={{ marginBottom : 0 }}>{storeName}</p>
                            <p className='stat-title'>배달 분석</p>
                            {
                                !isActive &&
                                <p className='warn-text'>* 아래 보여지는 차트는 가상의 데이터입니다.</p>
                            }

                            <div>
                                <DeliveryChart info={isActive ? info.StatInfo.PriceStats.Delivery : delvieryMockData}/>
                            </div>

                            <div className='delivery-table'>
                                <div className='d-table-header'>
                                    <p>총 배달 매출</p>
                                    <p>{isActive ? convertCost(info.StatInfo.PriceStats.Delivery.Price) : '*,***,***'} 원</p>
                                </div>
                                <div className='d-table-body'>
                                    <div className='row between'>
                                        <p className='title'>주문 건당 평균 가격</p>
                                        <p className='title' style={{ color : '#3f3f3f' }}>{isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Delivery.Price/info.StatInfo.PriceStats.Delivery.Count) ) : '**,***'} 원</p>
                                    </div>
                                    <div className='row' style={{ marginTop : 4, paddingLeft : 4 }}>
                                        <div className='circle' style={{ backgroundColor : '#4fc8c4'}}></div>
                                        <p className='baemin-text' >배달의 민족 : {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Delivery.Platform.Baemin.Price/info.StatInfo.PriceStats.Delivery.Platform.Baemin.Count)) : '**,***'}원</p>
                                        <div className='circle' style={{ backgroundColor : '#f00c5a'}}></div>
                                        <p className='yogiyo-text'>요기요 : {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Delivery.Platform.Yogiyo.Price/info.StatInfo.PriceStats.Delivery.Platform.Yogiyo.Count)) : '**,***'}원</p>
                                        <div className='circle' style={{ backgroundColor : '#f8c800'}}></div>
                                        <p className='coupong-text'>쿠팡이츠 : {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Delivery.Platform.Eats.Price/info.StatInfo.PriceStats.Delivery.Platform.Eats.Count)) : '**,***'}원</p>
                                    </div>
                                </div>
                                <div className='d-table-body'>
                                    <div className='row between'>
                                        <p className='title'>평균 적립 포인트</p>
                                        <p className='title' style={{ color : '#3f3f3f' }}>{convertCost(parseInt(info.StatInfo.PointStats.Delivery.AddPoint/info.StatInfo.PointStats.Delivery.Add))} P</p>
                                    </div>
                                </div>
                                <div className='d-table-body'>
                                    <div className='row between'>
                                        <p className='title'>평균 사용 포인트</p>
                                        <p className='title' style={{ color : '#3f3f3f' }}>{convertCost(parseInt(info.StatInfo.PointStats.Delivery.UsedPoint/info.StatInfo.PointStats.Delivery.Used))} P</p>
                                    </div>
                                </div>
                            </div>

                            <div className='row' style={{ display : 'flex', alignItems : 'center', justifyContent : 'center', marginTop : 35 }}>
                                <div className='expect-badge'>
                                    포인트를 1회 사용하기 위해 발생된 예상 매출
                                </div>
                                <p className='expect-price'>{isActive ? convertCost(parseInt((info.StatInfo.PointStats.Delivery.UsedPoint/info.StatInfo.PointStats.Delivery.Used) / (info.StatInfo.PointStats.Delivery.AddPoint/info.StatInfo.PointStats.Delivery.Add) * (info.StatInfo.PriceStats.Delivery.Price/info.StatInfo.PriceStats.Delivery.Count))): '***,***'} 원</p>
                            </div>
                        </div>

                        <div className='stat-box' style={{ width : 460, height : 722, padding : 40, overflow : 'hidden' }}>
                            <p className='store-name' style={{ marginBottom : 0 }}>{storeName}</p>
                            <p className='stat-title' style={{ marginBottom : 8 }}>포인트 분석</p>
                            <RadioButtonGroup
                                value={pointType}
                                checked={pointType}
                                onChange={(val) => setPointType(val)}
                                options={[
                                    { value : 'add', label : '적립'},
                                    { value : 'use', label : '사용'}
                                ]}
                                perRows={6}
                                radioStyle={{ marginBottom : 16 }}
                                small
                                containerStyle={{ justifyContent : 'flex-start'}}
                                id='point'
                            />

                            <div>
                                <PointChart info={ info.StatInfo.PointStats} type={pointType}/>
                            </div>
                            
                            <div className='p-table-row'>
                                <div className='p-header'>
                                    적립
                                </div>
                                <div style={{ paddingLeft : 16 }}>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>총 적립 건수 : </p>
                                        <p className='title'>&nbsp;{convertCost(info.StatInfo.PointStats.Add)}건</p>
                                    </div>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>총 적립 포인트 : </p>
                                        <p className='title'>&nbsp;{convertCost(info.StatInfo.PointStats.AddPoint)} P</p>
                                    </div>
                                    <p className='warn-text' style={{ marginBottom : 4, marginTop : 0 }}>현재 적립비율 {info.PointRate}%</p>
                                </div>
                            </div>
                            <div className='p-table-row' style={{ border : 'none'}}>
                                <div className='p-header'>
                                    사용
                                </div>
                                <div style={{ paddingLeft : 16 }}>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>총 사용 건수 : </p>
                                        <p className='title'>&nbsp;{convertCost(info.StatInfo.PointStats.Used)}건</p>
                                    </div>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>총 사용 포인트 : </p>
                                        <p className='title'>&nbsp;{convertCost(info.StatInfo.PointStats.UsedPoint)} P</p>
                                    </div>
                                </div>
                            </div>
                            <div className='p-table-row'>
                                <div className='p-header'>
                                    평균
                                </div>
                                <div style={{ paddingLeft : 16 }}>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>평균 적립 포인트 : </p>
                                        <p className='title'>&nbsp;{convertCost(parseInt(info.StatInfo.PointStats.AddPoint/info.StatInfo.PointStats.Add))} P</p>
                                    </div>
                                    <div className='row'>
                                        <p className='store-name' style={{ marginBottom : 0}}>평균 사용 포인트 : </p>
                                        <p className='title'>&nbsp;{convertCost(parseInt(info.StatInfo.PointStats.UsedPoint/info.StatInfo.PointStats.Used))} P</p>
                                    </div>
                                </div>
                            </div>

                            <div className='row' style={{ display : 'flex', alignItems : 'center', justifyContent : 'center', marginTop : 32 }}>
                                <div className='expect-badge'>
                                    포인트를 1회 사용하기 위해 발생된 예상 매출
                                </div>
                                <p className='expect-price'>{isActive ? convertCost(parseInt((info.StatInfo.PointStats.UsedPoint/info.StatInfo.PointStats.Used) / (info.StatInfo.PointStats.AddPoint/info.StatInfo.PointStats.Add) * (info.StatInfo.PriceStats.Visit.Price/info.StatInfo.PriceStats.Visit.Count) )) : '***,***'} 원</p>
                            </div>
                        </div>
                    </div>

                    <div className='row between' style={{ marginTop : 40 }}>
                        <div className='stat-box' style={{ width : 460 }}>
                            <p className='store-name' style={{ marginBottom : 0 }}>{storeName}</p>
                            <p className='stat-title' style={{ marginBottom : 8 }}>연령별 통계</p>
                            <RadioButtonGroup
                                value={aegType}
                                onChange={(val) => setAgeType(val)}
                                options={[
                                    { value : 'add', label : '적립'},
                                    { value : 'use', label : '사용'}
                                ]}
                                perRows={6}
                                radioStyle={{ marginBottom : 24 }}
                                small
                                containerStyle={{ justifyContent : 'flex-start'}}
                                id="age"
                            />

                            <div>
                                <AgeChart info={info.StatInfo.PointStats.Age } type={aegType}/>
                            </div>
                        </div>

                        <div className='stat-box' style={{ width : 460 }}>
                            <p className='store-name' style={{ marginBottom : 0 }}>{storeName}</p>
                            <p className='stat-title' style={{ marginBottom : 8 }}>성별 통계</p>
                            <RadioButtonGroup
                                value={genderType}
                                onChange={(val) => setGenderType(val)}
                                options={[
                                    { value : 'add', label : '적립'},
                                    { value : 'use', label : '사용'}
                                ]}
                                perRows={6}
                                radioStyle={{ marginBottom : 24 }}
                                small
                                containerStyle={{ justifyContent : 'flex-start'}}
                                id="gender"
                            />

                            <div>
                                <GenderChart info={info.StatInfo.PointStats.Gender} type={genderType}/>
                            </div>
                        </div>
                    </div>

                    <Modal ref={modalRef} contentContainer={{ width : 500 }} isHeader title='쿠폰 타입별 통계'>
                        <div className='coupon-modal-box'>
                            <div className='row between' style={{ marginBottom : 20 }}>
                                <p className='coupon-name'>상품증정 쿠폰 통계</p>
                                <div>
                                    <p className='coupon-count'>{convertCost(info.StatInfo.CouponStats.FreeUsed)}건 {convertCost((info.StatInfo.CouponStats.FreeUsed/info.StatInfo.CouponStats.Issued * 100).toFixed(2))}%</p>
                                    <p className='coupon-roas'>발생매출 {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Price/info.StatInfo.PriceStats.Count * info.StatInfo.CouponStats.FreeUsed - info.StatInfo.CouponStats.FreeUsed * 44 )) : '***,***'}원</p>
                                </div>
                            </div>

                            <div className='row between' style={{ marginBottom : 20 }}>
                                <p className='coupon-name'>%할인 쿠폰 통계</p>
                                <div>
                                    <p className='coupon-count'>{convertCost(info.StatInfo.CouponStats.PerUsed)}건 {convertCost((info.StatInfo.CouponStats.PerUsed/info.StatInfo.CouponStats.Issued * 100).toFixed(2))}%</p>
                                    <p className='coupon-roas'>발생매출 {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Price/info.StatInfo.PriceStats.Count * info.StatInfo.CouponStats.PerUsed - info.StatInfo.CouponStats.PerUsed * 44 )) : '***,***'}원</p>
                                </div>
                            </div>

                            <div className='row between' style={{ marginBottom : 20 }}>
                                <p className='coupon-name'>원할인 쿠폰 통계</p>
                                <div>
                                    <p className='coupon-count'>{convertCost(info.StatInfo.CouponStats.WonUsed)}건 {convertCost((info.StatInfo.CouponStats.WonUsed/info.StatInfo.CouponStats.Issued * 100).toFixed(2))}%</p>
                                    <p className='coupon-roas'>발생매출 {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Price/info.StatInfo.PriceStats.Count * info.StatInfo.CouponStats.WonUsed - info.StatInfo.CouponStats.WonUsed * 44 )) : '***,***'}원</p>
                                </div>
                            </div>

                            <div className='row between'>
                                <p className='coupon-name'>1+1할인 쿠폰 통계</p>
                                <div>
                                    <p className='coupon-count'>{convertCost(info.StatInfo.CouponStats.OnePlusUsed)}건 {convertCost((info.StatInfo.CouponStats.OnePlusUsed/info.StatInfo.CouponStats.Issued * 100).toFixed(2))}%</p>
                                    <p className='coupon-roas'>발생매출 {isActive ? convertCost(parseInt(info.StatInfo.PriceStats.Price/info.StatInfo.PriceStats.Count * info.StatInfo.CouponStats.OnePlusUsed - info.StatInfo.CouponStats.OnePlusUsed * 44 )) : '***,***'}원</p>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal ref={calendarModalRef}  contentContainer={{ width : 1000, height : 900, padding : 0 }}>
                        <>
                            <div className='month-row between'>
                                <div> </div>
                                <div className='row'>
                                    <button onClick={() => handleCalendarDate('back')} className='month-btn'>
                                        <img alt='icon' src={require('../../aseets/icons/chevron_left.svg').default} style={{ width : 32, height : 32 }} />
                                    </button>
                                    <p className='month-text'>{calendarYear}.{calendarMonth}</p>
                                    <button onClick={() => handleCalendarDate('next')} className='month-btn'>
                                        <img alt='icon' src={require('../../aseets/icons/chevron_right.svg').default} style={{ width : 32, height : 32 }} />
                                    </button>
                                </div>
                                <div onClick={() => calendarModalRef.current.closeModal()}>
                                    <img alt='icon' src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24 }} />
                                </div>
                            </div>
                            <Calendar
                                ref={calendarRef}
                                localizer={localizer}
                                startAccessor="start"
                                endAccessor="end"
                                events={calendarStat}
                                eventPropGetter={eventPropGetter}
                                defaultDate={new Date()}
                                date={moment(calendarYear + '-' + calendarMonth + '-01' )}
                                onShowMore={onShowMore}
                                popup={false}
                                timeslots={0}
                                doShowMoreDrillDown={false}
                                onNavigate={(e) => console.log(e)}
                                culture="ko"
                            />
                        </>
                    </Modal>

                    <Modal ref={moreCalendarRef} isHeader title={moment(moreDate.date).format('YYYY-MM-DD')} contentContainer={{ width : 350 }}>
                        <div>
                            {
                                Object.keys(moreDate).length > 0 &&
                                <div>
                                    <p className='more-highlight'>{moreDate.event[0].title}</p>
                                    <p className='more-text'>{moreDate.event[1].title}</p>
                                    <p className='more-highlight' style={{ marginTop : 8 }}>{moreDate.event[2].title}</p>
                                    <p className='more-text'>{moreDate.event[3].title}</p>
                                    <p className='more-text'>{moreDate.event[4].title}</p>
                                </div>
                            }
                        </div>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default Stats;